/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const adminOverviewBannerClinicsNeedingAttentionMin = 0
export const adminOverviewBannerClinicsNeedingAttentionMax = 9007199254740991

export const adminOverviewCountsActiveClinicsMin = 0
export const adminOverviewCountsActiveClinicsMax = 9007199254740991

export const adminOverviewCountsBookings7dMin = 0
export const adminOverviewCountsBookings7dMax = 9007199254740991

export const adminOverviewCountsBookingsTodayMin = 0
export const adminOverviewCountsBookingsTodayMax = 9007199254740991

export const adminOverviewCountsErrors24hMin = 0
export const adminOverviewCountsErrors24hMax = 9007199254740991

export const adminOverviewCountsErrors7dMin = 0
export const adminOverviewCountsErrors7dMax = 9007199254740991

export const adminOverviewNeedsAttentionItemClinicIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const adminOverviewNeedsAttentionItemSinceOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const adminOverviewRecentErrorsItemClinicIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const adminOverviewRecentErrorsItemContextLocationOneIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const adminOverviewRecentErrorsItemContextProviderOneIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const adminOverviewRecentErrorsItemContextSlotStartOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const adminOverviewRecentErrorsItemContextVisitTypeOneIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const adminOverviewRecentErrorsItemGroupIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const adminOverviewRecentErrorsItemHttpStatusOneMin = -9007199254740991
export const adminOverviewRecentErrorsItemHttpStatusOneMax = 9007199254740991

export const adminOverviewRecentErrorsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const adminOverviewRecentErrorsItemOccurredAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)

export const AdminOverview = zod.object({
  banner: zod.object({
    clinicsNeedingAttention: zod
      .int()
      .min(adminOverviewBannerClinicsNeedingAttentionMin)
      .max(adminOverviewBannerClinicsNeedingAttentionMax),
    state: zod.enum(['all_operational', 'needs_attention', 'probe_not_running']),
  }),
  counts: zod.object({
    activeClinics: zod.int().min(adminOverviewCountsActiveClinicsMin).max(adminOverviewCountsActiveClinicsMax),
    bookings7d: zod.int().min(adminOverviewCountsBookings7dMin).max(adminOverviewCountsBookings7dMax),
    bookingsToday: zod.int().min(adminOverviewCountsBookingsTodayMin).max(adminOverviewCountsBookingsTodayMax),
    errors24h: zod.int().min(adminOverviewCountsErrors24hMin).max(adminOverviewCountsErrors24hMax),
    errors7d: zod.int().min(adminOverviewCountsErrors7dMin).max(adminOverviewCountsErrors7dMax),
  }),
  hasClinics: zod.boolean(),
  needsAttention: zod.array(
    zod.object({
      clinic: zod.object({
        id: zod.uuid().regex(adminOverviewNeedsAttentionItemClinicIdRegExp),
        name: zod.string(),
        slug: zod.string(),
      }),
      problem: zod.enum([
        'keeper_down',
        'no_heartbeat',
        'pf_logged_out',
        'pf_awaiting_code',
        'errors_above_normal',
        'never_connected',
      ]),
      since: zod.union([
        zod.iso.datetime({ offset: true }).regex(adminOverviewNeedsAttentionItemSinceOneRegExp),
        zod.null(),
      ]),
    }),
  ),
  recentErrors: zod.array(
    zod.object({
      clinic: zod
        .object({
          id: zod.uuid().regex(adminOverviewRecentErrorsItemClinicIdRegExp),
          name: zod.string(),
          slug: zod.string(),
        })
        .optional(),
      code: zod.string(),
      context: zod.object({
        location: zod.union([
          zod.object({
            id: zod.uuid().regex(adminOverviewRecentErrorsItemContextLocationOneIdRegExp),
            name: zod.string(),
          }),
          zod.null(),
        ]),
        provider: zod.union([
          zod.object({
            id: zod.uuid().regex(adminOverviewRecentErrorsItemContextProviderOneIdRegExp),
            name: zod.string(),
          }),
          zod.null(),
        ]),
        slotStart: zod.union([
          zod.iso.datetime({ offset: true }).regex(adminOverviewRecentErrorsItemContextSlotStartOneRegExp),
          zod.null(),
        ]),
        visitType: zod.union([
          zod.object({
            id: zod.uuid().regex(adminOverviewRecentErrorsItemContextVisitTypeOneIdRegExp),
            name: zod.string(),
          }),
          zod.null(),
        ]),
      }),
      groupId: zod.uuid().regex(adminOverviewRecentErrorsItemGroupIdRegExp),
      httpStatus: zod.union([
        zod.int().min(adminOverviewRecentErrorsItemHttpStatusOneMin).max(adminOverviewRecentErrorsItemHttpStatusOneMax),
        zod.null(),
      ]),
      id: zod.uuid().regex(adminOverviewRecentErrorsItemIdRegExp),
      message: zod.string(),
      occurredAt: zod.iso.datetime({ offset: true }).regex(adminOverviewRecentErrorsItemOccurredAtRegExp),
      requestId: zod.string(),
      source: zod.string().nullable(),
      step: zod.enum(['pf_lookup', 'availability', 'hold', 'pf_write', 'pf_message', 'pf_login']),
    }),
  ),
})

export type AdminOverview = zod.input<typeof AdminOverview>
export type AdminOverviewOutput = zod.output<typeof AdminOverview>
